export default {
  data(){
     return {
       audioInputContext: null,
       audioInputAnalyser: null,
       audioInputMediaStream: null,
       audioInputProcessor: null,
       audioStreamValue: null,
     }
  },
  computed:{
    selectedAudioInputDevice(){
      return this.$store.state.media.audioInputDevice;
    },
  },
  methods : {
    initAudioContext(){
      var AudioContext = window.AudioContext // Default
        || window.webkitAudioContext // Safari and old versions of Chrome
        || false;
      this.audioInputContext = new AudioContext;
      this.audioInputAnalyser = this.audioInputContext.createAnalyser();
      this.audioInputProcessor = this.audioInputContext.createScriptProcessor(2048, 1, 1);
    },
    startAudioInputStream() {
      navigator.mediaDevices.getUserMedia({
        audio: {
          sampleRate: 44000,
          sampleSize: 16,
          channelCount: 2,
          deviceId: this.selectedAudioInputDevice,
          volume: 0
        },
        video: false
      }).then((stream) => {
          const temp = () => {
            if (this.audioInputAnalyser) {
              let array = new Uint8Array(this.audioInputAnalyser.frequencyBinCount), values = 0;
              this.audioInputAnalyser.getByteFrequencyData(array);
              array.forEach((a, index) => {
                values += (array[index]);
              });
              this._audioStreamValue = parseInt((values / array.length).toFixed(0));
            }
          };
          this.audioInputMediaStream = this.audioInputContext.createMediaStreamSource(stream);
          this.audioInputAnalyser.smoothingTimeConstant = 0.8;
          this.audioInputAnalyser.fftSize = 1024;
          this.audioInputMediaStream.connect(this.audioInputAnalyser);
          this.audioInputAnalyser.connect(this.audioInputProcessor);
          this.audioInputProcessor.connect(this.audioInputContext.destination);
          this.audioInputProcessor.onaudioprocess = temp;
          this._interval = setInterval(() => {
            this.audioStreamValue = this._audioStreamValue;
          }, 100);
        },
        () => {
          this.permission = false;
        }
      )
    },
    stopAudioInputStream() {
      this.audioStreamValue=null;
      clearInterval(this._interval);
      this._interval = null;
      if (this.audioInputProcessor) {
        this.audioInputProcessor.disconnect();
        this.audioInputProcessor = null;
      }
      if (this.audioInputAnalyser) {
        this.audioInputAnalyser.disconnect();
        this.audioInputAnalyser = null;
      }
      if (this.audioInputContext) {
        this.audioInputContext = null;
      }
      if (this.audioInputMediaStream) {
        let tracks = this.audioInputMediaStream.mediaStream.getTracks();
        tracks.forEach(t => t.stop());
        this.audioInputMediaStream = null;
      }
    }
  },
  beforeDestroy() {
    this.stopAudioInputStream();
  }
}